<template>
  <section class="section">
    <div class="container" v-if="roleid == 28">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ກວດສອບຜົນຜະລິດເຂົ້າຕະຫຼາດ 
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" >
        <b-tab-item label="ຜົນຜະລິດ ລໍຖ້າກວດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field >
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-centered " width="10%">
                        ວັນທີ
                      </th>
                      <th  class="has-text-left" width="20%">
                        ຕະຫຼາດ
                      </th>
                      <th  width="30%">
                        ຊື່ຟາມ/ ເບີໂທ
                      </th>
                      
                      <th  class="has-text-centered" width="15%">
                        ຈຳນວນສິນຄ້າ
                      </th>
                      <th   class="has-text-centered" width="15%">
                        ລາຍລະອຽດ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in waitcheckedproducts" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td   class="has-text-centered">
                        {{ data.MARKETDATE }}
                      </td>
                      <td  >
                        {{ data.MARKETNAME }}
                      </td>
                      <td  >
                        {{ data.FARMNAME }} / {{ data.PHONENO }}
                      </td>
                      
                      <td  class="has-text-centered">
                        {{ data.NUMOFPRODUCT | formatNumberLocal}}
                      </td>
                      <td   class="has-text-centered">
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                productDetail(data.MARKETDATE, data.FARMID, 0)
                              "
                              >ລາຍລະອຽດ
                            </b-button>
                        </b-field>

                        
                      </td>
                      
                    
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ຜົນຜະລິດ ທີ່ຜ່ານການກວດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field >
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-centered " width="10%">
                        ວັນທີ
                      </th>
                      <th  class="has-text-left" width="20%">
                        ຕະຫຼາດ
                      </th>
                      <th  width="30%">
                        ຊື່ຟາມ/ ເບີໂທ
                      </th>
                      
                      <th  class="has-text-centered" width="15%">
                        ຈຳນວນສິນຄ້າ
                      </th>
                      <th   class="has-text-centered" width="15%">
                        ລາຍລະອຽດ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in checkedproducts" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td   class="has-text-centered">
                        {{ data.MARKETDATE }}
                      </td>
                      <td  >
                        {{ data.MARKETNAME }}
                      </td>
                      <td  >
                        {{ data.FARMNAME }} / {{ data.PHONENO }}
                      </td>
                      
                      <td  class="has-text-centered">
                        {{ data.NUMOFPRODUCT | formatNumberLocal}}
                      </td>
                      <td   class="has-text-centered">
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                productDetail(data.MARKETDATE, data.FARMID, 1)
                              "
                              >ລາຍລະອຽດ
                            </b-button>
                        </b-field>

                        
                      </td>
                      
                    
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ຜົນຜະລິດ ທີ່ບໍ່ຜ່ານການກວດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field >
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-centered " width="10%">
                        ວັນທີ
                      </th>
                      <th  class="has-text-left" width="20%">
                        ຕະຫຼາດ
                      </th>
                      <th  width="30%">
                        ຊື່ຟາມ/ ເບີໂທ
                      </th>
                      
                      <th  class="has-text-centered" width="15%">
                        ຈຳນວນສິນຄ້າ
                      </th>
                      <th   class="has-text-centered" width="15%">
                        ລາຍລະອຽດ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in notpassproducts" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td   class="has-text-centered">
                        {{ data.MARKETDATE }}
                      </td>
                      <td  >
                        {{ data.MARKETNAME }}
                      </td>
                      <td  >
                        {{ data.FARMNAME }} / {{ data.PHONENO }}
                      </td>
                      
                      <td  class="has-text-centered">
                        {{ data.NUMOFPRODUCT | formatNumberLocal}}
                      </td>
                      <td   class="has-text-centered">
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                productDetail(data.MARKETDATE, data.FARMID, -1)
                              "
                              >ລາຍລະອຽດ
                            </b-button>
                        </b-field>

                        
                      </td>
                      
                    
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
        <b-tab-item label="ລາຍລະອຽດ">
          <div class="columns scrollme">
            <div class="column">
              <b-field>
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="5%">
                        ລະຫັດ
                      </th>
                      <th class="has-text-left " width="20%">
                        ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="30%">
                        ສິນຄ້າ
                      </th>
                      <th  width="30%">
                        ຈຳນວນ/ ຫົວໜ່ວຍ
                      </th>
                      <th   class="has-text-centered" width="15%" >
                        <b-field v-if="selectedIschecked ==0">
                          ຈັດການ
                        </b-field>
                        <b-field v-if="selectedIschecked !=0">
                          ສະຖານະ
                        </b-field>
                        
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in marketproductdetail" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td   class="has-text-left">
                        {{ data.ID }}
                      </td>
                      <td   class="has-text-left">
                        {{ data.MARKETNAME }}
                      </td>
                      <td   class="has-text-left">
                        {{ data.PRODUCTNAME }}
                      </td>
                      <td  class="has-text-center">
                        {{ data.QUANTITYIN }}  {{ data.UNIT }} 
                      </td>
                      
                      <td   class="has-text-centered" v-if="data.ISCHECKED == 0">
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                productMarketCheck(data.ID,data.MARKETDATE, data.FARMID, 1)
                              "
                              >ອະນຸມັດ
                            </b-button>
                        </b-field>

                        <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-warning"
                              size="is-small"
                              @click="
                                productMarketCheck(data.ID,data.MARKETDATE, data.FARMID, -1)
                              "
                              >ບໍ່ອະນຸມັດ
                            </b-button>
                        </b-field>                        
                      </td>

                      <td   class="has-text-centered" v-if="data.ISCHECKED != 0">
                        <b-field v-if="data.ISCHECKED== 1">
                           ຜ່ານ
                        </b-field>
                        <b-field v-if="data.ISCHECKED== -1">
                           ບໍ່ຜ່ານ
                        </b-field>

                                           
                      </td>
                     
                    
                    </tr>
                  </tbody>
                  
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,
      activeTab: 0,
      checkedproducts: [],
      waitcheckedproducts: [],
      notpassproducts: [],
      marketproductdetail: [],
      selectedMarketdate : null,
      selectedFarmid: null,
      selectedIschecked: null,
      

    };
  },
  methods: {
    getGroupProductCheck() {
      RestAPI.getGroupProductCheck()
        .then(res => {
          console.log("list:"+ JSON.stringify(res.data))
          this.checkedproducts = res.data.checkedProduct;
          this.waitcheckedproducts = res.data.waitcheckedProduct;
          this.notpassproducts = res.data.notpassProduct;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    productDetail(marketdate, farmid, ischecked){
      this.activeTab = 3;
      this.selectedMarketdate = marketdate;
      this.selectedFarmid = farmid;
      this.selectedIschecked = ischecked;

      RestAPI.getGroupProductCheckDetail(marketdate, farmid, ischecked)
        .then(res => {
          console.log("list:"+ JSON.stringify(res.data))
          this.marketproductdetail = res.data;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    productMarketCheck(id, marketdate, farmid, status){
      this.activeTab = 3;

      var params = {
          id: id,
          status: status,
          username: this.username
        };

      RestAPI.checkProductMarket(params)
        .then(() => {
          this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
          this.getGroupProductCheck();
          this.productDetail(this.selectedMarketdate,this.selectedFarmid,this.selectedIschecked)
          // this.activeTab =0;
        })
        .catch(error => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    }
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;

    this.getGroupProductCheck();
   

  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
